module.exports = __webpack_public_path__ + "static/Felis-D2-76ee022c9193f9aa2583612b9ff86c42.pdf";